export default "__VITE_ASSET__gVwacmra__"